import React, { useState } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import { Menu, ClipboardCheck, Clock, RefreshCw, User, KeyRound, LogOut, ChevronDown, Eye, EyeOff, Search, FlaskConical, AlertTriangle, ExternalLink } from "lucide-react";
//import Header from "../components/header/Header";
import { Outlet } from "react-router-dom";
import { Browser } from "@syncfusion/ej2-base";
import { useNavigate, useLocation } from "react-router-dom";
import * as Actions from "../redux/actions/user.actions";
import * as ProcessActions from "../redux/actions/process.actions";
import { toast } from "../components/toast";
import {
  AppBarComponent,
  TreeViewComponent,
  SidebarComponent,
} from "@syncfusion/ej2-react-navigations";
import { DialogUtility } from "@syncfusion/ej2-react-popups";
import { ButtonComponent } from "@syncfusion/ej2-react-buttons";

import Utils from "../utils/Utils";
import Typography from "../components/customdesign/Typography";
import { useSelector, useDispatch } from "react-redux";

import { findValueById, find, getErrorTasksSummary, getCookie, setCookie, isAdminUser } from "../utils/Functions";

import UserMenuTree from "../components/header/UserMenuTree";
import UserProfileDrawer from "../components/profile/UserProfileDrawer";
import ThemeToggle from "../theme/ThemeToggle";
import LanguageSelector from "../theme/LanguageSelector";
import CommandPalette from "../components/command/CommandPalette";

let dialogObj;
let old_password;
let password;
let password2;
const MainLayout = ({ openPanel, setOpenPanel }) => {
  let WFListInstance;
  let MListInstance;
  let CListInstance;

  const [windowHeight, setWindowHeight] = React.useState(window.innerHeight);
  const {
    defConfig,
    params,
    defLang,
    activeForm,
    usertoken,
    username,
    userid,
    menu,
    menuWFL,
    customMenu,
    menuTemplates,
    useracronym,
    tasks,
    tasksV2,
    role,
    isNew,
    gettingResumeTasks,
    environment,
  } = useSelector((state) => state.Login);
  const { refreshResumeTasks } = useSelector((state) => state.Process);
  const isTestEnv = !!environment && environment.toUpperCase() === "TEST";

  const [menuFields, setMenuFields] = React.useState({});
  const [openProfile, setOpenProfile] = React.useState(false);
  const [userMenuOpen, setUserMenuOpen] = React.useState(false);
  const [pwModalOpen, setPwModalOpen] = React.useState(false);
  const [showPw, setShowPw] = React.useState({ old: false, new1: false, new2: false });
  const userMenuRef = React.useRef(null);
  const triggerRef = React.useRef(null);
  const dropdownRef = React.useRef(null);
  const [dropPos, setDropPos] = React.useState({ top: 0, right: 0 });
  // Desktop (>=901) abre/acopla el nav; <901 es drawer móvil (cerrado por defecto).
  const [navOpen, setNavOpen] = React.useState(window.innerWidth >= 901);

  const [dataSourceWFL, setDataSourceWFL] = React.useState([]);

  const [totalAssigned, setTotalAssigned] = React.useState(0);
  const [totalActives, setTotalActives] = React.useState(0);
  const [totalOuts, setTotalOuts] = React.useState(0);

  const [dataSource, setDataSource] = React.useState([]);
  const [dataSourceC, setDataSourceC] = React.useState([]);
  const [dataSourceD, setDataSourceD] = React.useState([]);
  const { pathname: path } = useLocation();

  const width = "280px";
  const target = ".main-sidebar-content";
  const mediaQuery = "(min-width: 901px)";
  const windowWidth = window.innerWidth;
  const closeSidebarOnMobile = () => {
    // En móvil/tablet (<901) el menú debe cerrarse al elegir una opción.
    // Antes usaba <=600 → en 601-900px no cerraba. Se usa hide() explícito
    // (no toggle) para que nunca reabra por desincronía de estado.
    if (window.innerWidth < 901 && sidebarobj) {
      if (typeof sidebarobj.hide === "function") sidebarobj.hide();
      else sidebarobj.toggle();
      setNavOpen(false);
    }
  };

  /* ── Recuperación del sidebar al volver a desktop ─────────────────────────
     En desktop (>=901px) la visibilidad del nav la controla la clase
     .xflow-nav-open/.xflow-nav-closed (translateX). El callback `close` de
     Syncfusion apaga navOpen cuando el ancho es <=900 (drawer móvil/tablet),
     pero nada lo volvía a encender al regresar a desktop → el sidebar quedaba
     deslizado fuera (translateX(-100%)) dejando una franja en blanco y el menú
     "desaparecido". Este listener restaura navOpen al cruzar a desktop. */
  React.useEffect(() => {
    if (!userMenuOpen) return;
    const handler = (e) => {
      const inTrigger = triggerRef.current?.contains(e.target);
      const inDropdown = dropdownRef.current?.contains(e.target);
      if (!inTrigger && !inDropdown) setUserMenuOpen(false);
    };
    document.addEventListener("mousedown", handler);
    document.addEventListener("touchstart", handler, { passive: true });
    return () => {
      document.removeEventListener("mousedown", handler);
      document.removeEventListener("touchstart", handler);
    };
  }, [userMenuOpen]);

  const prevWidthRef = React.useRef(window.innerWidth);
  React.useEffect(() => {
    const onResize = () => {
      const w = window.innerWidth;
      // Al pasar de móvil/tablet (<901) a desktop (>=901), reabrir el nav.
      // En desktop la visibilidad la maneja el CSS (.xflow-nav-open); no se
      // llama a sidebarobj.show() para no desincronizar el estado interno de
      // Syncfusion (ver comentarios en `toggle` y en el `close` del Sidebar).
      if (prevWidthRef.current < 901 && w >= 901) {
        setNavOpen(true);
      }
      prevWidthRef.current = w;
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const loadPage = (event) => {
    let _link = findValueById(dataSource, event, "id", "link");
    if (_link) {
      navigate(_link);
    }
    closeSidebarOnMobile();
  };

  const loadPageC = (event) => {
    let _link = findValueById(dataSourceC, event, "id", "link");
    if (_link) {
      navigate(_link);
    }
    closeSidebarOnMobile();
  };

  const loadPageD = (event) => {
    let _link = findValueById(dataSourceD, event, "id", "link");
    if (_link) {
      navigate(_link);
    }
    closeSidebarOnMobile();
  };

  const loadPageWFL = (event) => {
    if (event.indexOf("TASK") >= 0) {
      const node = menuWFLData ? menuWFLData.find((n) => String(n.id) === String(event)) : null;
      if (node?.link) {
        navigate(node.link);
      } else {
        /* Fallback: formato TASK_{gid}_{fid}_{tid} */
        const _link = event.split("_");
        navigate("/getTasks/" + _link[3] + "/" + _link[2]);
      }
    } else if (event.indexOf("SEARCH") >= 0) {
      navigate("/searchWF/");
    }
    closeSidebarOnMobile();
  };

  const loadPageTemplate = (event) => {
    const node = menuTemplatesData.find((n) => String(n.id) === String(event));
    if (node && node.link) {
      navigate(node.link);
      closeSidebarOnMobile();
    }
  };
  const navigate = useNavigate();
  React.useEffect(() => {
    if (!usertoken && !Utils.excludeSideBar.includes(path)) {
      navigate("/login");

      //window.location.reload();
    } else {
      let data = [];

      if (isNew) {
        setTimeout(() => setPwModalOpen(true), 250);
      }
      let goToCustomMenu = [];
      menu.map(function (key) {
        let userRole = true;
        if (userRole) {
          let id = key.id;
          let item = {
            id: id,
            pid: 999999,
            name: key.title,
            label: defConfig[defLang][key.code],
            hasChild: key.items ? true : false,
          };
          if (key.link) {
            item["link"] = key.link;
          }

          data.push(item);
          if (key.items) {
            key.items.map(function (key2) {
              let item = {
                id: key2.id,
                name: key2.title,
                label: defConfig[defLang][key2.code],
                hasChild: key2.items ? true : false,
                pid: id,
                link: key2.link,
              };
              if (key2.isPage) {
                //console.log("is page!!!")
                goToCustomMenu.push(key2);
              } else {
                data.push(item);
              }

              if (key2.items) {
                let id = key2.id;
                key2.items.map(function (key3) {
                  let item = {
                    id: key3.id,
                    name: key3.title,
                    label: defConfig[defLang][key3.code],
                    hasChild: key3.items ? true : false,
                    pid: id,
                    link: key3.link,
                  };
                  data.push(item);
                });
              }
            });
          }
        }
      });

      let item = {
        id: 999999,
        name: "Administration",
        label: defConfig[defLang]["administrationlabel"],
        hasChild: true,
        type: "root",
        link: "#",
      };
      data.push(item);
      //console.log("data", data);
      let fields = {
        dataSource: data,
        id: "id",
        parentID: "pid",
        text: "name",
        hasChildren: "hasChild",
      };
      //      console.log("fields", fields);

      setMenuFields(fields);
      if (data.length > 2) {
        setDataSource(data);
      } else {
        setDataSource([]);
      }

      let tmpGroups = [];
      let cdata = [];
      let contMenu = 1;
      /*      console.log("m", menu);
      console.log("cm", customMenu);
      console.log("pages", goToCustomMenu);
      */
      goToCustomMenu.map(function (key) {
        let item = {
          id: key.id,
          name: key.title,
          hasChild: key.items ? true : false,
          pid: 999997,
          link: key.link,
        };
        cdata.push(item);
      });

      customMenu.map(function (key) {
        if (tmpGroups.indexOf(key.group) < 0) {
          tmpGroups.push(key.group);
          // console.log("entr", key.group)
          let item = {
            id: contMenu,
            pid: 999997,
            name: key.group,
            hasChild: true,
          };

          cdata.push(item);

          customMenu.map(function (key2) {
            if (key.group === key2.group) {
              let item = {
                id: key2.id,
                name: key2.title,
                hasChild: key2.items ? true : false,
                pid: contMenu,
                link: key2.link,
              };
              cdata.push(item);
            }
          });
          contMenu++;
        }
      });

      let itemC = {
        id: 999997,
        name: "Pages",
        label: defConfig[defLang]["pageslabel"],
        hasChild: true,
        type: "root",
        link: "#",
      };
      cdata.push(itemC);
      setDataSourceC(cdata);

      let ddata = [
        /*
        {
          id: 999987,
          name: "Developer Center",
          label: defConfig[defLang]["developercenterlabel"],
          hasChild: true,
          type: "root",
          link: "#",
        },*/
        {
          id: 999985,
          name: "My Connectors",
          label: defConfig[defLang]["myapislabel"],
          pid: 999987,
          link: "/manage/connectors",
        },
        {
          id: 999986,
          name: "Community Connectors",
          label: defConfig[defLang]["communityapislabel"],
          pid: 999987,
          link: "/public/connectors",
        },
      ];

      if (userid === "0") {
        let newElement = {
          id: 999987,
          name: "Developer Center",
          label: defConfig[defLang]["developercenterlabel"],
          hasChild: true,
          type: "root",
          link: "#",
        };
        ddata = [newElement].concat(ddata);
      }

      //console.log(ddata);
      setDataSourceD(ddata);

      if (tasks === undefined) {
        dispatch(Actions.getResumeTasksByUser());
      } else if (!tasksV2 || tasksV2.length === 0) {
        dispatch(Actions.getResumeTasksByUserV2());
      }

      if (menuWFL && menuWFL.length > 0) {
        let groupAssingned = 0;
        let groupActives = 0;
        let groupOuts = 0;

        let groups = [];
        let flows = [];

        menuWFL.map(function (g) {
          if (groups.indexOf(g.FLOWGROUPID) < 0) {
            let hasChildG = false;
            menuWFL.map((f) => {
              let flowActives = 0;
              let flowAssigned = 0;
              let flowOuts = 0;
              if (f.FLOWGROUP === g.FLOWGROUP) {
                hasChildG = true;
                if (flows.indexOf(f.FLOWID) < 0) {
                  let hasChildF = false;
                  let fid = f.FLOWID;
                  let _tasks = [];
                  menuWFL.map((t) => {
                    if (f.FLOWID === t.FLOWID) {
                      if (_tasks.indexOf(t.TASKID) < 0) {
                        let taskActives = 0;
                        let taskAssigned = 0;
                        let taskOuts = 0;
                        tasks.map(function (key) {
                          if (
                            key.FLOWID === t.FLOWID &&
                            key.TASKID === t.TASKID
                          ) {
                            (taskActives = key.TOTAL),
                              (taskAssigned = parseInt(key.TOTAL_ASSIGNED));
                            taskOuts = parseInt(key.TOTAL_OUT);
                          }
                        });
                        hasChildF = true;
                        flowActives = flowActives + taskActives;
                        flowAssigned = flowAssigned + taskAssigned;
                        flowOuts = flowOuts + taskOuts;
                        if (t.oldVersion) {
                          if (taskActives >= 0) {
                            _tasks.push(fid + "_T" + t.TASKID);
                          }
                        } else {
                          _tasks.push(fid + "_" + t.TASKID);
                        }
                      }
                    }
                  });

                  flows.push(f.FLOWID);
                }
                groupActives = groupActives + flowActives;
                groupAssingned = groupAssingned + flowAssigned;
                groupOuts = groupOuts + flowOuts;
              }
            });
          }
        });
        setTotalActives(groupActives);
        setTotalAssigned(groupAssingned);
        setTotalOuts(groupOuts);
      }
    }
  }, [usertoken, menu, customMenu, menuWFL, tasks, refreshResumeTasks, isNew, path]);

  let sidebarobj;

  const set_menuWFL = (_menuWFL) => {
    let dataWFL = [];
    let groups = [];
    _menuWFL.map(function (g) {
      if (groups.indexOf(g.FLOWGROUPID) < 0) {
        let gid = g.FLOWGROUPID;
        let groupActives = 0;
        let hasChildG = false;
        /* Per-group flow dedup: same FLOWID can appear in different groups
           (e.g. a flow shared across Casaideas and Multicine offices). */
        let groupFlows = [];
        _menuWFL.map((f) => {
          let flowActives = 0;
          if (f.FLOWGROUP === g.FLOWGROUP) {
            hasChildG = true;
            if (groupFlows.indexOf(f.FLOWID) < 0) {
              let hasChildF = false;
              let fid = f.FLOWID;
              /* Unique IDs scoped by group so the same FLOWID in two groups
                 produces distinct tree nodes. */
              const flowNodeId = "FLOW_" + gid + "_" + fid;
              let _tasks = [];
              _menuWFL.map((t) => {
                /* Only pick tasks that belong to this group+flow combination. */
                if (f.FLOWID === t.FLOWID && t.FLOWGROUPID === g.FLOWGROUPID) {
                  if (_tasks.indexOf(t.TASKID) < 0) {
                    let taskActives = 0;
                    if (tasks) {
                      /* tasks ahora tiene una fila por FLOWID+TASKID+OFFICECODE;
                         sumar todas las oficinas para el total del menuWFL. */
                      tasks.forEach(function (key) {
                        if (key.FLOWID === t.FLOWID && key.TASKID === t.TASKID) {
                          taskActives += parseInt(key.TOTAL) || 0;
                        }
                      });
                    }

                    hasChildF = true;
                    flowActives = flowActives + taskActives;

                    const _taskBasePath = "/getTasks/" + t.TASKID + "/" + fid;

                    if (t.oldVersion) {
                      if (taskActives > 0) {
                        let item = {
                          id: "TASK_" + gid + "_" + fid + "_" + t.TASKID,
                          taskid: t.TASKID,
                          name: t.TASK,
                          hasChild: false,
                          pid: flowNodeId,
                          link: _taskBasePath,
                          actives: taskActives,
                          sort: t.SORTORDER_F + "_" + t.SORTORDER_T,
                          tooltip: t.TASK,
                        };
                        dataWFL.push(item);
                        _tasks.push(t.TASKID);
                      }
                    } else {
                      let item = {
                        id: "TASK_" + gid + "_" + fid + "_" + t.TASKID,
                        taskid: t.TASKID,
                        name: t.TASK,
                        tooltip: t.TASK,
                        hasChild: false,
                        pid: flowNodeId,
                        link: _taskBasePath,
                        actives: taskActives,
                        sort: t.SORTORDER_F + "_T" + t.SORTORDER_T,
                      };
                      dataWFL.push(item);
                      _tasks.push(t.TASKID);
                    }
                  }
                }
              });

              let item = {
                id: flowNodeId,
                name: f.FLOW,
                tooltip: f.FLOW,
                hasChild: hasChildF,
                pid: gid,
                actives: flowActives,
                sort: f.SORTORDER_F + "",
              };
              dataWFL.push(item);
              groupFlows.push(f.FLOWID);
            }
            groupActives = groupActives + flowActives;
          }
        });

        groups.push(g.FLOWGROUPID);
        let item = {
          id: gid,
          name: g.FLOWGROUP,
          hasChild: hasChildG,
          type: "root",
          actives: groupActives,
          sort: "1",
        };
        dataWFL.push(item);
      }
    });

    //    console.log("dataWFL",dataWFL)
    let item = {
      id: "SEARCH",
      pid: 999999,
      cssicon: "",
      name: "Search Flows",
      label: defConfig[defLang]["searchflowslabel"],
      hasChild: false,
      link: "/searchWF/",
      sort: "999998",
    };
    dataWFL.push(item);
    let itemM = {
      id: 999999,
      cssicon: "",
      name: "Flows",
      label: defConfig[defLang]["flowslabel"],
      hasChild: true,
      type: "root",
      link: "#",
      sort: "1",
    };
    //dataWFL.push(itemM);

    dataWFL.sort(function (a, b) {
      return b.sort > a.sort ? -1 : b.sort < a.sort ? 1 : 0;
    });
    return dataWFL;
  };

  const toggle = () => {
    const next = !navOpen;
    setNavOpen(next);
    // Desktop: CSS controla el transform via .xflow-nav-open/closed.
    // NO llamamos Syncfusion.show/hide en desktop — su backdrop click
    // podría cerrar el nav sin actualizar navOpen (desfase estado/CSS).
    // Móvil: Syncfusion maneja el drawer overlay.
    if (sidebarobj && window.innerWidth <= 900) {
      if (next) sidebarobj.show();
      else sidebarobj.hide();
    }
  };
  const dispatch = useDispatch();
  const logout = (event) => {
    if (dialogObj) {
      dialogObj.hide();
    }

    dispatch(Actions.logout());
  };

  const updatePassword = (event) => {
    let isInvalid = false;
    let message = "";
    if (password.value.length < 8) {
      message = defConfig[defLang].messagePasswordVal0;
      isInvalid = true;
    } else {
      if (password.value !== password2.value) {
        message = defConfig[defLang].messagePasswordVal1;
        isInvalid = true;
      } else {
        if (password.value === old_password.value) {
          message = defConfig[defLang].messagePasswordVal2;
          isInvalid = true;
        }
      }
    }
    if (isInvalid) {
      toast.error(message);
    } else {
      let data = {
        password: password.value,
        old_password: old_password.value,
      };
      dispatch(Actions.updatePassword(data));
      setPwModalOpen(false);
      setShowPw({ old: false, new1: false, new2: false });
      old_password.value = "";
      password.value = "";
      password2.value = "";
    }
  };

  const openLogoutConfirm = () => {
    dialogObj = DialogUtility.confirm({
      title: defConfig[defLang].logoutlabel,
      content:
        '<div class="new" style="margin:13px 0;display:flex;flex-direction:column;align-items:center;">' +
        '<p><span class="circle-border"><span class="e-icons e-export" style="position:relative;top:3px;font-size:20px;padding:5px 0 0 0;font-weight:700;"></span></span>' +
        ' <b style="font-size:18px;font-weight:500!important;">' +
        defConfig[defLang].confirmlogout +
        "</b></p></div>",
      okButton: { click: logout.bind(this), text: defConfig[defLang].logoutlabel, cssClass: "e-primary" },
      cancelButton: { click: cancelDialog, text: defConfig[defLang].cancellabel },
      animationSettings: { effect: "Fade", delay: 0, duration: 400 },
      style: { width: 320 },
      position: { X: "center", Y: "center" },
    });
  };

  const cancelDialog = (args) => {
    //console.log("cancel")
    dialogObj.hide();
  };

  // Memoiza el árbol de flujos: sin esto se reconstruye en cada render
  // (p.ej. al cambiar inputs del body que despachan a redux) y el TreeView
  // parpadea / "desaparece" un instante.
  const menuWFLData = React.useMemo(
    () => set_menuWFL(menuWFL),
    [menuWFL, tasks, defConfig, defLang]
  );

  const set_menuTemplates = (_templates, _tasksV2) => {
    if (!_templates || _templates.length === 0) return [];
    const data = [];
    const sectionsSeen = {};   // { sectionId → index in data[] }
    const sectionTotals = {};  // { sectionId → accumulated actives }

    _templates.forEach((tpl) => {
      const sectionId   = "TSEC_" + (tpl.section?.id || tpl.id);
      const sectionName = tpl.section?.name || "Otros";
      const tplId       = "TPL_" + tpl.id;

      if (!sectionsSeen[sectionId]) {
        sectionsSeen[sectionId] = data.length;
        sectionTotals[sectionId] = 0;
        data.push({
          id:         sectionId,
          name:       sectionName,
          tooltip:    sectionName,
          hasChild:   true,
          type:       "root",
          actives:    0,
          badgeClass: "xflow-menu-count--section",
          sort:       "2",
        });
      }

      const officeCode = tpl.section?.code || null;
      let tplActives = 0;
      const flowTaskNodes = (tpl.flowTasks || []).map((ft, idx) => {
        let count = 0;
        if (_tasksV2 && _tasksV2.length > 0 && officeCode) {
          const match = _tasksV2.find(
            (t) => Number(t.FLOWID) === Number(ft.flowid) &&
                   Number(t.TASKID) === Number(ft.taskid) &&
                   t.OFFICECODE === officeCode
          );
          if (match) count = parseInt(match.TOTAL) || 0;
        }
        tplActives += count;
        const taskLink = officeCode
          ? "/getTasks/" + officeCode + "/" + ft.taskid + "/" + ft.flowid
          : "/getTasks/" + ft.taskid + "/" + ft.flowid;
        return {
          id:         tplId + "_" + ft.flowid + "_" + ft.taskid,
          name:       ft.task,
          tooltip:    ft.task,
          hasChild:   false,
          pid:        tplId,
          link:       taskLink,
          actives:    count,
          badgeClass: "xflow-menu-count--tpl",
          sort:       "2_" + String(idx).padStart(3, "0"),
          officecode: officeCode,
        };
      });

      /* Acumular total en el nodo de sección */
      sectionTotals[sectionId] += tplActives;
      data[sectionsSeen[sectionId]].actives = sectionTotals[sectionId];

      data.push({
        id:         tplId,
        name:       tpl.description || tpl.name,
        tooltip:    tpl.description || tpl.name,
        hasChild:   flowTaskNodes.length > 0,
        pid:        sectionId,
        actives:    tplActives,
        badgeClass: "xflow-menu-count--tpl",
        sort:       "2",
      });

      flowTaskNodes.forEach((n) => data.push(n));
    });

    return data;
  };

  const menuTemplatesData = React.useMemo(
    () => set_menuTemplates(menuTemplates, tasksV2),
    [menuTemplates, tasks, tasksV2]
  );

  /* Items planos para el Command Palette (Ctrl/⌘ K). Hojas con link real. */
  const commandItems = React.useMemo(() => {
    const collect = (arr, group, icon) =>
      (arr || [])
        .filter((it) => it.link && it.link !== "#")
        .map((it) => ({
          id: group + "::" + it.id,
          label: it.label || it.name,
          group,
          link: it.link,
          icon,
        }));
    const builtins = [
      { id: "app::home", label: defConfig[defLang]?.mytaskslabel || "Inicio", group: "App", link: "/", icon: "e-home" },
      { id: "app::dashboard", label: "Dashboard", group: "App", link: "/dashboard", icon: "e-chart-line" },
      { id: "app::searchwf", label: defConfig[defLang]?.searchflowslabel || "Buscar flujos", group: "App", link: "/SearchWF", icon: "e-search" },
    ];
    return [
      ...builtins,
      ...collect(menuWFLData, defConfig[defLang]?.flowslabel || "Flujos", "e-group-2"),
      ...collect(dataSourceC, defConfig[defLang]?.pageslabel || "Páginas", "e-file-new"),
      ...collect(menuTemplatesData, "Menu Personalizado", "e-file-document"),
      ...collect(dataSource, defConfig[defLang]?.administrationlabel || "Administración", "e-settings"),
      ...collect(dataSourceD, "Developer", "e-code-view"),
    ];
  }, [menuWFLData, dataSourceC, menuTemplatesData, dataSource, dataSourceD, defConfig, defLang]);

  return Utils.excludeSideBar.indexOf(path) >= 0 ? (
    <Outlet />
  ) : (
    <div
      className={
        "control-container " + (navOpen ? "xflow-nav-open" : "xflow-nav-closed")
      }
      id="responsive-wrapper"
>
      {pwModalOpen && (
        <div
          className="xum-modal-overlay"
          onClick={(e) => { if (!isNew && e.target === e.currentTarget) { setPwModalOpen(false); setShowPw({ old: false, new1: false, new2: false }); } }}
        >
          <div className="xum-modal">
            <div className="xum-modal-header">
              <div className="xum-modal-icon"><KeyRound size={20} /></div>
              <div style={{ flex: 1 }}>
                <p className="xum-modal-title">{defConfig[defLang].changepassword}</p>
                <p className="xum-modal-subtitle">{defConfig[defLang].messagePasswordVal0 || "Mínimo 8 caracteres"}</p>
              </div>
              {!isNew && (
                <button className="xum-modal-close" onClick={() => { setPwModalOpen(false); setShowPw({ old: false, new1: false, new2: false }); }}>
                  <ChevronDown size={18} style={{ transform: "rotate(-90deg)" }} />
                </button>
              )}
            </div>
            <div className="xum-modal-body">
              <div className="xum-field">
                <label className="xum-label">{defConfig[defLang].oldpasswordlabel}</label>
                <div className="xum-input-wrap">
                  <input type={showPw.old ? "text" : "password"} className="xum-input" placeholder="••••••••"
                    ref={(el) => { old_password = el; }} />
                  <button type="button" className="xum-eye" onClick={() => setShowPw(p => ({ ...p, old: !p.old }))}>
                    {showPw.old ? <EyeOff size={16} /> : <Eye size={16} />}
                  </button>
                </div>
              </div>
              <div className="xum-field">
                <label className="xum-label">{defConfig[defLang].newpasswordlabel}</label>
                <div className="xum-input-wrap">
                  <input type={showPw.new1 ? "text" : "password"} className="xum-input" placeholder="••••••••"
                    ref={(el) => { password = el; }} />
                  <button type="button" className="xum-eye" onClick={() => setShowPw(p => ({ ...p, new1: !p.new1 }))}>
                    {showPw.new1 ? <EyeOff size={16} /> : <Eye size={16} />}
                  </button>
                </div>
              </div>
              <div className="xum-field">
                <label className="xum-label">{defConfig[defLang].repeatpasswordlabel}</label>
                <div className="xum-input-wrap">
                  <input type={showPw.new2 ? "text" : "password"} className="xum-input" placeholder="••••••••"
                    ref={(el) => { password2 = el; }} />
                  <button type="button" className="xum-eye" onClick={() => setShowPw(p => ({ ...p, new2: !p.new2 }))}>
                    {showPw.new2 ? <EyeOff size={16} /> : <Eye size={16} />}
                  </button>
                </div>
              </div>
            </div>
            <div className="xum-modal-footer">
              {!isNew && (
                <button className="xum-btn xum-btn--ghost" onClick={() => { setPwModalOpen(false); setShowPw({ old: false, new1: false, new2: false }); }}>
                  {defConfig[defLang].cancellabel}
                </button>
              )}
              <button className="xum-btn xum-btn--primary" onClick={updatePassword}>
                {defConfig[defLang].changelabel}
              </button>
            </div>
          </div>
        </div>
      )}

      <CommandPalette items={commandItems} />

      <div id="reswrapper">
        <div>
          <span id="statusText"></span>
          <AppBarComponent
            className={`appBarHeader xflow-appbar${isTestEnv ? " xflow-appbar--test" : ""}`}
            style={{ padding: 0 }}
          >
            <ButtonComponent
              cssClass="e-inherit xflow-menu-toggle"
              onClick={toggle}
            ><Menu size={20} /></ButtonComponent>
            <div className="e-folder xflow-appbar-brand">
              <div className="e-folder-name">
                <img
                  onClick={() => {
                    navigate("/");
                  }}
                  style={{ height: "34px", cursor: "pointer" }}
                  onError={(event) => {
                    event.currentTarget.src = "/images/logo_mini_w.png";
                  }}
                  src={
                    process.env.REACT_APP_CUSTOM_LOGO_IMAGE_MINI ||
                    "/images/logo_mini_w.png"
                  }
                />
              </div>
              {!Browser.isDevice && (
                <span className="xflow-appbar-title">
                  {(process.env.REACT_APP_NAME || "xFlow").replace(/^"|"$/g, "")}
                </span>
              )}
              {isTestEnv && (
                <span className="xflow-appbar-test-tag" title="Ambiente de pruebas, no es producción">
                  <FlaskConical size={13} strokeWidth={2.4} />
                  {Browser.isDevice ? "TEST" : "AMBIENTE DE PRUEBAS"}
                </span>
              )}
            </div>
            <div className="e-appbar-spacer e-appbar-item"></div>
            <button
              type="button"
              className="xflow-cmdk-trigger"
              title="Búsqueda rápida (Ctrl/⌘ K)"
              aria-label="Búsqueda rápida"
              onClick={() => window.dispatchEvent(new Event("xflow:open-command-palette"))}
            >
              <Search size={16} />
              {!Browser.isDevice && (
                <>
                  <span className="xflow-cmdk-trigger-text">{defConfig[defLang].searchlabel || "Buscar"}</span>
                  <kbd className="xflow-cmdk-trigger-kbd">Ctrl K</kbd>
                </>
              )}
            </button>
            <div className="xflow-appbar-actions">
              <LanguageSelector />
              <ThemeToggle />
              {totalOuts > 0 && (
                <button type="button" className="xflow-pill xflow-pill--success">
                  <ClipboardCheck size={15} strokeWidth={2.2} />
                  {!Browser.isDevice && (
                    <span className="xflow-pill-label">{defConfig[defLang].taken}</span>
                  )}
                  {totalAssigned > 0 && (
                    <span className="xflow-pill-count">{totalAssigned}</span>
                  )}
                </button>
              )}
              {totalOuts > 0 && (
                <button type="button" className="xflow-pill xflow-pill--danger">
                  <Clock size={15} strokeWidth={2.2} />
                  {!Browser.isDevice && (
                    <span className="xflow-pill-label">{defConfig[defLang].expired}</span>
                  )}
                  {totalAssigned > 0 && (
                    <span className="xflow-pill-count">{totalOuts}</span>
                  )}
                </button>
              )}
              {isAdminUser() && (
                <ErrorTasksPill defConfig={defConfig} defLang={defLang} navigate={navigate} isMobile={Browser.isDevice} />
              )}
              <div className="xum-wrap" ref={userMenuRef}>
                <button
                  ref={triggerRef}
                  type="button"
                  className="xum-trigger"
                  onClick={() => {
                    if (!userMenuOpen && triggerRef.current) {
                      const r = triggerRef.current.getBoundingClientRect();
                      setDropPos({
                        top: r.bottom + 8,
                        right: window.innerWidth - r.right,
                      });
                    }
                    setUserMenuOpen(o => !o);
                  }}
                  aria-haspopup="true"
                  aria-expanded={userMenuOpen}
                >
                  <span className="e-avatar e-avatar-small e-avatar-circle">{useracronym}</span>
                  <ChevronDown size={12} className={"xum-chevron" + (userMenuOpen ? " xum-chevron--open" : "")} />
                </button>
              </div>
              {userMenuOpen && ReactDOM.createPortal(
                <div
                  ref={dropdownRef}
                  className="xum-dropdown xum-dropdown--portal"
                  style={{ top: dropPos.top, right: dropPos.right }}
                >
                  <div className="xum-header">
                    <span className="xum-username">{username}</span>
                    <span className="xum-role">{role === 1 ? "Administrador" : "Usuario"}</span>
                  </div>
                  <div className="xum-divider" />
                  <button className="xum-item" onClick={() => { setUserMenuOpen(false); setOpenProfile(true); }}>
                    <User size={15} />
                    <span>{defConfig[defLang].myprofilelabel || "Mi Perfil"}</span>
                  </button>
                  <button className="xum-item" onClick={() => { setUserMenuOpen(false); setPwModalOpen(true); }}>
                    <KeyRound size={15} />
                    <span>{defConfig[defLang].changepassword}</span>
                  </button>
                  <div className="xum-divider" />
                  <button className="xum-item xum-item--danger" onClick={() => { setUserMenuOpen(false); openLogoutConfirm(); }}>
                    <LogOut size={15} />
                    <span>{defConfig[defLang].logoutlabel}</span>
                  </button>
                </div>,
                document.body
              )}
            </div>
          </AppBarComponent>
        </div>
        <SidebarComponent
          id="sideTree"
          className="sidebar-treeview"
          ref={(Sidebar) => (sidebarobj = Sidebar)}
          width={width}
          target={target}
          closeOnDocumentClick={false}
          showBackdrop={false}
          mediaQuery={mediaQuery}
          type={"Over"}
          isOpen={windowWidth >= 901}
          close={() => {
            // En desktop el sidebar se controla via CSS (xflow-nav-open/closed).
            // Syncfusion puede disparar `close` por scroll o eventos internos —
            // ignorarlo en desktop para evitar desfase de estado.
            if (window.innerWidth <= 900 && navOpen) setNavOpen(false);
          }}
        >
          <div className="res-main-menu">
            <div className="table-content primary xflow-sidebar-content">
              <div className="main-menu-header mt-4 xflow-sidebar-profile">
                {/* <!-- Card Component --> */}

                <div className="e-card-content e-avatar-content xflow-sidebar-avatar">
                  {/* <!-- XLarge Circle Avatar Component --> */}
                  <div className="e-avatar e-avatar-xxlarge e-avatar-circle">
                    <img
                      onClick={() => {
                        navigate("/");
                      }}
                      style={{ cursor: "pointer" }}
                      className="image"
                      src="/images/users/user.png"
                      alt="avatar"
                    />
                  </div>
                </div>

                <Typography variant="h4" mb="0" style={{ textAlign: "center" }}>
                  {defConfig[defLang].welcomeh1}
                </Typography>
                <Typography
                  variant="h4"
                  mb="30"
                  style={{ fontWeight: 700, textAlign: "center" }}
                >
                  <p
                    className={
                      (!Browser.isDevice ? "h4" : "h2") +
                      " text-bold primary-color mb-1 xflow-sidebar-username"
                    }
                  >
                    {username}
                  </p>
                  <ButtonComponent
                    id="refresh-wfl-menu"
                    cssClass="e-flat e-primary e-menu-icon-refresh xflow-refresh-menu"
                    onClick={() => {
                      dispatch(Actions.getSimpleResumeTasksByUser());
                    }}
                  ><RefreshCw size={15} /></ButtonComponent>
                </Typography>

                {dataSourceC.length > 1 &&
                  process.env.REACT_APP_HIDE_FIRSTPAGES && (
                    <>
                      <UserMenuTree
                        userid={userid}
                        dataSource={dataSourceC}
                        name={"customMenu"}
                        nodeClicked={loadPageC}
                        cssClass="template-tree"
                      />
                    </>
                  )}

                {gettingResumeTasks ? (
                  <div className="xflow-menu-skeleton">
                    {[
                      { child: false, w: "88%" },
                      { child: true,  w: "72%" },
                      { child: true,  w: "65%" },
                      { child: true,  w: "78%" },
                      { child: false, w: "82%" },
                      { child: true,  w: "60%" },
                      { child: true,  w: "70%" },
                    ].map((row, i) => (
                      <div
                        key={i}
                        className={"xflow-menu-skeleton-item" + (row.child ? " xflow-menu-skeleton-item--child" : "")}
                        style={{ width: row.w, opacity: 1 - i * 0.08 }}
                      />
                    ))}
                  </div>
                ) : tasks.length >= 0 ? (
                  <>
                    <UserMenuTree
                      userid={userid}
                      dataSource={menuWFLData}
                      name={"menuWFL"}
                      nodeClicked={loadPageWFL}
                      cssClass="template-tree"
                    />
                    {menuTemplatesData.length > 0 && (
                      <UserMenuTree
                        userid={userid}
                        dataSource={menuTemplatesData}
                        name={"menuTemplates"}
                        nodeClicked={loadPageTemplate}
                        cssClass="template-tree"
                      />
                    )}
                  </>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      marginLeft: 40,
                      position: "relative",
                      top: 3,
                      marginBottom: 8,
                    }}
                  >
                    <span className={"e-flows-gray"}> </span>
                    <span
                      style={{ fontWeight: 500, fontSize: 16, paddingTop: 3 }}
                      className="treeName"
                    >
                      {defConfig[defLang].flowslabel}
                    </span>
                  </div>
                )}

                {dataSource.length > 1 && (
                  <>
                    <UserMenuTree
                      userid={userid}
                      dataSource={dataSource}
                      name={"menu"}
                      nodeClicked={loadPage}
                      cssClass="template-tree"
                    />
                  </>
                )}

                {dataSourceC.length > 1 &&
                  !process.env.REACT_APP_HIDE_FIRSTPAGES && (
                    <>
                      <UserMenuTree
                        userid={userid}
                        dataSource={dataSourceC}
                        name={"customMenu"}
                        nodeClicked={loadPageC}
                        cssClass="template-tree"
                      />
                    </>
                  )}

                {dataSourceD.length > 0 && role == 1 && (
                  <>
                    <UserMenuTree
                      userid={userid}
                      dataSource={dataSourceD}
                      name={"devMenu"}
                      nodeClicked={loadPageD}
                      cssClass="template-tree"
                    />
                  </>
                )}
              </div>
            </div>
            <div></div>
          </div>
        </SidebarComponent>
        <div
          className={
            "main-sidebar-content xflow-main-content" +
            (path.indexOf("/manage") < 0 ? " xflow-user-workspace" : "")
          }
          id="main-text"
          style={
            window.innerWidth > 900
              ? {
                  marginLeft: navOpen ? 280 : 0,
                  width: navOpen ? "calc(100% - 280px)" : "100%",
                  transition: "margin-left 0.28s ease, width 0.28s ease",
                }
              : undefined
          }
        >
          <div
            className="sidebar-content"
            style={{ height: "100%", padding: Browser.isDevice ? 5 : 20 }}
          >
            <div
              className={
                "border-bottom-style-1 e-card e-custom-card" +
                (path.indexOf("/manage") < 0 ? " xflow-content-surface" : "")
              }
              style={{
                minHeight: windowHeight - 100,
                background: path === "/public/connectors" ? "var(--xflow-canvas, #fafafa)" : "var(--xflow-surface, #fff)",
              }}
            >
              <Outlet />
            </div>
          </div>
        </div>
      </div>

      {/* ── Profile drawer ── */}
      <UserProfileDrawer
        open={openProfile}
        onClose={() => setOpenProfile(false)}
        userid={userid}
        defConfig={defConfig}
        defLang={defLang}
      />
    </div>
  );
};

/* ─────────────────────────────────────────────────────────────
   ErrorTasksPill — pill del header con las tareas en STATUSID=5
   (error). Carga el resumen una vez y lo cachea 1h en cookie para
   no pegarle al backend en cada render/navegacion; el boton de
   refrescar del dropdown fuerza una relectura y renueva la cookie.
───────────────────────────────────────────────────────────── */
function ErrorTasksPill({ defConfig, defLang, navigate, isMobile }) {
  const COOKIE_KEY = (process.env.REACT_APP_NAME || "xflow") + "_error_tasks_summary_v1";
  const L = defConfig?.[defLang] || {};

  const [open, setOpen] = React.useState(false);
  const [summary, setSummary] = React.useState({ total: 0, hasMore: false, tasks: [] });
  const [loading, setLoading] = React.useState(false);
  const [expandedId, setExpandedId] = React.useState(null);
  const [pos, setPos] = React.useState({ top: 0, right: 0 });
  const triggerRef = React.useRef(null);
  const dropdownRef = React.useRef(null);

  const readCookie = () => {
    try {
      const raw = getCookie(COOKIE_KEY);
      if (!raw) return null;
      return JSON.parse(decodeURIComponent(raw));
    } catch (_) {
      return null;
    }
  };

  const writeCookie = (data) => {
    try {
      setCookie(COOKIE_KEY, encodeURIComponent(JSON.stringify(data)), 1);
    } catch (_) {}
  };

  const load = React.useCallback(async (force) => {
    if (!force) {
      const cached = readCookie();
      if (cached) { setSummary(cached); return; }
    }
    setLoading(true);
    const resp = await getErrorTasksSummary();
    setLoading(false);
    if (resp?.status) {
      const data = { total: resp.total || 0, hasMore: !!resp.hasMore, tasks: resp.tasks || [] };
      setSummary(data);
      writeCookie(data);
    }
  }, []);

  React.useEffect(() => { load(false); }, [load]);

  React.useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      const inTrigger = triggerRef.current?.contains(e.target);
      const inDropdown = dropdownRef.current?.contains(e.target);
      if (!inTrigger && !inDropdown) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  if (summary.total <= 0 && !loading) return null;

  const goToSearch = (task) => {
    const start = task.startDate ? new Date(task.startDate) : new Date();
    const from = new Date(start); from.setDate(from.getDate() - 1);
    const to = new Date(start); to.setDate(to.getDate() + 1);
    const qs = new URLSearchParams({
      wfpflowid: String(task.wfpflowid),
      flowid: String(task.flowid),
      from: from.toISOString(),
      to: to.toISOString(),
    });
    setOpen(false);
    navigate("/searchWF/?" + qs.toString());
  };

  const displayCount = summary.hasMore ? `${summary.tasks.length}+` : String(summary.total);

  return (
    <div className="xflow-pill-wrap" ref={triggerRef}>
      <button
        type="button"
        className="xflow-pill xflow-pill--warning"
        onClick={() => {
          if (!open && triggerRef.current) {
            const r = triggerRef.current.getBoundingClientRect();
            setPos({ top: r.bottom + 8, right: window.innerWidth - r.right });
          }
          setOpen((o) => !o);
        }}
      >
        <AlertTriangle size={15} strokeWidth={2.2} />
        {!isMobile && (
          <span className="xflow-pill-label">{L.errorTasksLabel || "Errores"}</span>
        )}
        <span className="xflow-pill-count">{displayCount}</span>
      </button>

      {open && ReactDOM.createPortal(
        <div ref={dropdownRef} className="xerr-dropdown" style={{ top: pos.top, right: pos.right }}>
          <div className="xerr-header">
            <span>{L.errorTasksTitle || "Tareas con error"}</span>
            <button
              type="button"
              className="xerr-refresh"
              title={L.refreshlabel || "Actualizar"}
              onClick={() => load(true)}
              disabled={loading}
            >
              <RefreshCw size={13} className={loading ? "xerr-spin" : ""} />
            </button>
          </div>

          {summary.tasks.length === 0 ? (
            <div className="xerr-empty">{L.noErrorTasks || "Sin tareas en error"}</div>
          ) : (
            <div className="xerr-list">
              {summary.tasks.map((t) => {
                const isItemOpen = expandedId === t.taskId;
                return (
                  <div key={t.taskId} className="xerr-item">
                    <button
                      type="button"
                      className="xerr-item-head"
                      onClick={() => setExpandedId(isItemOpen ? null : t.taskId)}
                    >
                      <div className="xerr-item-main">
                        <span className="xerr-item-flow">{t.flowName}</span>
                        <span className="xerr-item-task">{t.taskName}</span>
                      </div>
                      <span className="xerr-item-ids">#{t.wfpflowid} / #{t.taskId}</span>
                      <ChevronDown size={13} className={"xerr-chevron" + (isItemOpen ? " xerr-chevron--open" : "")} />
                    </button>
                    {isItemOpen && (
                      <div className="xerr-item-body">
                        <div className="xerr-item-msg">{(t.message || "").slice(0, 300) || "—"}</div>
                        <button type="button" className="xerr-item-link" onClick={() => goToSearch(t)}>
                          <ExternalLink size={12} />
                          {L.viewInSearcher || "Ver en buscador"}
                        </button>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}

          {summary.hasMore && (
            <div className="xerr-more">{L.andMoreErrors || "y más…"}</div>
          )}
        </div>,
        document.body
      )}
    </div>
  );
}

MainLayout.propTypes = {};

export default MainLayout;
